import React, { useState, useEffect } from "react";

/*eslint-disable */

declare const window: any;

interface CaracteristicasVehiculosComponentProps {
  caracteristicas: any;
}

const CaracteristicasVehiculosComponent: React.FC<
  CaracteristicasVehiculosComponentProps
> = ({ caracteristicas }) => {
  const [currentIndex, setCurrentIndex] = useState(1); // Inicialmente se muestra la imagen en el centro
  const [windowWidth, setWindowWidth] = useState(window.innerWidth); // Almacena el ancho de la pantalla

  // Actualiza el ancho de la pantalla cada vez que se cambia el tamaño de la ventana
  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };

    // Agrega el event listener para escuchar cambios en el tamaño de la ventana
    window.addEventListener("resize", handleResize);

    // Limpia el event listener cuando el componente se desmonte
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const handlePrev = () => {
    setCurrentIndex((prevIndex) =>
      prevIndex > 0 ? prevIndex - 1 : caracteristicas?.tecnologia?.length - 1
    );
  };

  const handleNext = () => {
    setCurrentIndex((prevIndex) =>
      prevIndex < caracteristicas?.tecnologia?.length - 1 ? prevIndex + 1 : 0
    );
  };

  return (
    <div className="caracteristica-vehiculos-detail-component">
      <div className="title-tecnologia-vehiculos-detail-component">
        Tecnología que asiste tu viaje
      </div>
      <div
        className="btn-carrousel-caracteristica-vehiculos-detail-component prev"
        onClick={handlePrev}
      >
        <img src="/assets/01_Home/Icon_Left.svg" alt="Anterior" />
      </div>
      <div
        className="carrousel-caracteristica-vehiculos-detail-component"
        style={{
          transform:
            currentIndex === 0
              ? `translateX(${windowWidth < 768 ? "10%" : "25%"})`
              : `translateX(-${
                  windowWidth < 768
                    ? currentIndex * 70 === 70
                      ? currentIndex * 70
                      : /* : currentIndex * 70 === 140
                    ? currentIndex * 70 + 10 */
                        currentIndex * 80 - 10
                    : currentIndex * 25 === 25
                    ? currentIndex * 25
                    : currentIndex * 25 === 50
                    ? currentIndex * 25 + 25
                    : currentIndex * 50 + 25 - 50
                }%)`,
        }}
      >
        {caracteristicas?.tecnologia?.map((item: any, index: any) =>
          item?.media !== null ? (
            <div
              className={`item-caracteristica-vehiculos-detail-component`}
              key={index}
            >
              <img
                src={`https://manager.hyundaicolombia.co/${item?.media?.url}`}
                alt={item?.title || "Imagen de tecnología del vehículo"}
              />
            </div>
          ) : null
        )}
      </div>
      <div
        className="btn-carrousel-caracteristica-vehiculos-detail-component next"
        onClick={handleNext}
      >
        <img src="/assets/01_Home/Icon_Right.svg" alt="Siguiente" />
      </div>
      <div className="info-caracteristica-vehiculos-detail-component">
        <div className="title-caracteristica-vehiculos-detail-component">
          {caracteristicas?.tecnologia[currentIndex]?.title}
        </div>
        <div className="descripcion-caracteristica-vehiculos-detail-component">
          {caracteristicas?.tecnologia[currentIndex]?.description}
        </div>
        <div className="index-caracteristica-vehiculos-detail-component">
          {caracteristicas?.tecnologia?.map((item: any, index: number) => (
            <div
              className={`${index === currentIndex ? "active" : ""}`}
              onClick={() => setCurrentIndex(index)}
              key={index}
            ></div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default CaracteristicasVehiculosComponent;
